import { useLocation, useParams } from "react-router-dom";
import { useDeleteBookExamMutation } from "@/data/ielts.ts";
import { BookExamItem } from "@/types";
import Spinner from "@/components/ui/Loader.tsx";
import PageHeading from "@/components/ui/PageHeading.tsx";
import { Button } from "@/components/ui/Button.tsx";
import IELTSIcon from "@/components/icons/IELTSIcon.tsx";
import CalendarIllustration from "@/components/ui/CalendarIllustration.tsx";
import dayjs from "dayjs";

const DISCOUNT_CODE = import.meta.env.EDS_BRITISH_COUNCIL_CODE;

export function ExamDetails() {
  const location = useLocation();

  const routeParams = location?.state as BookExamItem;

  const { id } = useParams();
  const { mutate, isLoading } = useDeleteBookExamMutation();

  const handleBookIelts = () => {
    window.open(routeParams.link_exam, "_blank");
  };

  return (
    <>
      {!routeParams ? (
        <Spinner showText />
      ) : (
        <>
          <PageHeading
            title={"IELTS exam"}
            titleClassName={"!text-light"}
            subtitleClassName={"!text-light !text-lg"}
            subtitle={
              "Check the info on the British council page and submit a request to get a discount code to book the exam"
            }
          />
          <div className={"flex flex-col h-full my-4 md:my-0 gap-y-4 "}>
            <h5 className=" text-2xl md:text-4xl font-bold text-center text-white">
              Recap of your request
            </h5>
            <div
              className={
                "flex flex-row items-center justify-center gap-x-4 md:gap-x-6 px-3 md:px-0"
              }
            >
              <CalendarIllustration
                showStroke={false}
                className={"w-[100px] lg:w-[200px] h-auto"}
                day={dayjs(routeParams?.date_exam).format("DD")}
                month={dayjs(routeParams?.date_exam).format("MMM")}
              />
              <div className="h-full space-y-3">
                <p className="text-lg md:text-xl  mt-2 text-white">
                  Place Of exam
                </p>
                <p className="text-xl  md:text-3xl  xl:text-6xl font-semibold text-white capitalize">
                  {routeParams?.location}
                </p>
                <p className="text-lg md:text-xl  mt-2 text-white">Method</p>
                <p className="text-xl md:text-3xl xl:text-6xl font-semibold text-white">
                  IELTS on {routeParams?.method}
                </p>
              </div>
            </div>

            <div className="flex flex-col h-full  justify-between 3xl:justify-center 3xl:gap-y-20 gap-y-8 py-8 mb-auto">
              {!routeParams.link_exam ? (
                <>
                  <h5 className="text-lg  md:text-3xl xl:text-4xl 3xl:text-6xl font-semibold text-center text-white">
                    We are processing your request...
                  </h5>
                  <p className="  text-sm  md:text-base xl:text-lg 3xl:text-3xl text-center text-white">
                    Please check again this page in the next days to get the
                    link to book the exam
                  </p>
                  <h5 className=" text-lg md:text-3xl xl:text-4xl   3xl:text-6xl  font-semibold text-center  text-white">
                    Did you do something wrong?
                  </h5>
                  <Button
                    type="submit"
                    className={"w-full max-w-md mx-auto"}
                    disabled={isLoading}
                    isLoading={isLoading}
                    onClick={() => {
                      if (id) {
                        mutate(Number(id));
                      }
                    }}
                  >
                    Delete your request
                  </Button>
                </>
              ) : (
                <>
                  <h5 className="text-lg  md:text-3xl xl:text-4xl 3xl:text-6xl  font-semibold text-center text-white xl:leading-relaxed">
                    Click the button to book the exam. <br /> Your discount code
                    is : {DISCOUNT_CODE}{" "}
                  </h5>
                  <div className="w-fit mx-auto my-4">
                    <IELTSIcon className={"w-64 h-auto"} />
                  </div>
                  <Button
                    type="submit"
                    className={"w-full max-w-[577px] mx-auto"}
                    onClick={handleBookIelts}
                  >
                    Book your exam here
                  </Button>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ExamDetails;
